const state = {
	loading: true,
	fatal: null,
};

const mutations = {
	setLoading(state, loading) {
		state.loading = loading;
	},
	setFatal(state, message) {
		state.fatal = message;
		if (message) {
			console.log('Fatal error: ' + message);
		}
	},
};

const actions = {
	init({ state, commit }, loading) {
		commit('setLoading', true);
		commit('setFatal', null);
	},

	setLoading({ state, commit }, loading) {
		commit('setLoading', loading);
	},

	async fatal({ state, commit, rootGetters, dispatch }, { message }) {
		commit('setFatal', message);
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
};
